import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function QuoteCalculator() {
  return <section className="py-24 bg-museum-blue" data-id="element-245">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-246">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-247">
          {/* Left: Content */}
          <div className="text-white" data-id="element-248">
            <h2 className="text-4xl md:text-5xl font-serif font-bold mb-6 tracking-tight" data-id="element-249">
              Ready to get started?
            </h2>
            <p className="text-white/80 text-xl mb-8 leading-relaxed" data-id="element-250">
              Tell us about your project and we'll send you a custom quote
              within 2 hours. No commitment required.
            </p>

            <ul className="space-y-4 mb-8" data-id="element-251">
              <li className="flex items-center gap-3 text-white/90" data-id="element-252">
                <div className="w-2 h-2 bg-white rounded-full" data-id="element-253"></div>
                Transparent pricing with no hidden fees
              </li>
              <li className="flex items-center gap-3 text-white/90" data-id="element-254">
                <div className="w-2 h-2 bg-white rounded-full" data-id="element-255"></div>
                Volume discounts automatically applied
              </li>
              <li className="flex items-center gap-3 text-white/90" data-id="element-256">
                <div className="w-2 h-2 bg-white rounded-full" data-id="element-257"></div>
                Free design proofs before production
              </li>
            </ul>
          </div>

          {/* Right: Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-3xl p-8 lg:p-10 shadow-2xl" data-id="element-258">
            <h3 className="text-2xl font-serif font-bold text-museum-black mb-2" data-id="element-259">
              Get a Quick Quote
            </h3>
            <p className="text-museum-subtle text-sm mb-8" data-id="element-260">
              Fill out the form and we'll be in touch shortly.
            </p>

            <form className="space-y-5" data-id="element-261">
              <div className="grid grid-cols-2 gap-4" data-id="element-262">
                <input type="text" placeholder="First Name" className="w-full px-4 py-3.5 bg-museum-gray border-none rounded-xl focus:ring-2 focus:ring-museum-blue/20 outline-none text-sm" data-id="element-263" />
                <input type="text" placeholder="Last Name" className="w-full px-4 py-3.5 bg-museum-gray border-none rounded-xl focus:ring-2 focus:ring-museum-blue/20 outline-none text-sm" data-id="element-264" />
              </div>

              <input type="email" placeholder="Work Email" className="w-full px-4 py-3.5 bg-museum-gray border-none rounded-xl focus:ring-2 focus:ring-museum-blue/20 outline-none text-sm" data-id="element-265" />

              <input type="text" placeholder="Institution / Organization" className="w-full px-4 py-3.5 bg-museum-gray border-none rounded-xl focus:ring-2 focus:ring-museum-blue/20 outline-none text-sm" data-id="element-266" />

              <select className="w-full px-4 py-3.5 bg-museum-gray border-none rounded-xl focus:ring-2 focus:ring-museum-blue/20 outline-none text-sm text-museum-black" data-id="element-267">
                <option value="" data-id="element-268">Select a product category...</option>
                <option value="ceramics" data-id="element-269">Custom Ceramics</option>
                <option value="stationery" data-id="element-270">Journals & Stationery</option>
                <option value="apparel" data-id="element-271">Apparel & Totes</option>
                <option value="prints" data-id="element-272">Art Prints</option>
                <option value="other" data-id="element-273">Other / Multiple</option>
              </select>

              <textarea placeholder="Tell us about your project (optional)" rows={3} className="w-full px-4 py-3.5 bg-museum-gray border-none rounded-xl focus:ring-2 focus:ring-museum-blue/20 outline-none text-sm resize-none" data-id="element-274"></textarea>

              <button type="button" className="w-full bg-museum-blue text-white font-semibold py-4 rounded-full hover:bg-museum-dark transition-colors flex items-center justify-center gap-2 group shadow-lg shadow-museum-blue/25" data-id="element-275">
                Request Quote
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-276" />
              </button>

              <p className="text-xs text-center text-gray-400" data-id="element-277">
                No commitment required. We respect your privacy.
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}